import { Loader2 } from "lucide-react";

export default function Loading({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center py-24" data-testid="dashboard-loading">
      <div className="flex flex-col items-center gap-3 text-slate-400">
        <Loader2 className="h-6 w-6 animate-spin text-[#4F8CFF]" />
        <span className="text-sm">{label}</span>
      </div>
    </div>
  );
}
